// In tokenService.js
import { jwtDecode } from 'jwt-decode';

// Setting token in localStorage
export const setToken = (token) => {
    if (!token) {
        console.error('Attempted to set null/undefined token');
        return;
    }
    localStorage.setItem('jwtToken', token);
};

// Getting token from localStorage
export const getToken = () => {
    return localStorage.getItem('jwtToken');
};

// Remove token from localStorage
export const removeToken = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userId');
    sessionStorage.removeItem('user');
};

// Check if token exists and is not expired
export const isValidToken = () => {
    const token = getToken();
    if (!token) {
        return false;
    }

    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        // Check token expiration
        if (decodedToken.exp && decodedToken.exp < currentTime) {
            // Token is expired, clean up
            removeToken();
            return false;
        }

        return true;
    } catch (error) {
        console.error('Error decoding token:', error);
        removeToken(); // Invalid token, remove it
        return false;
    }
};

// Get user role from localStorage
export const getRole = () => {
    if (!isValidToken()) {
        return null;
    }

    const role = localStorage.getItem('userRole');

    // Handle both formats of roles (with or without ROLE_ prefix)
    if (role === 'ADMIN' || role === 'ROLE_ADMIN') {
        return 'ROLE_ADMIN';
    } else if (role === 'USER' || role === 'ROLE_USER') {
        return 'ROLE_USER';
    } else if (role === 'SUBADMIN' || role === 'ROLE_SUBADMIN') {
        return 'ROLE_SUBADMIN';
    }

    return role;
};

// Get user ID from localStorage
export const getUserId = () => {
    if (!isValidToken()) {
        return null;
    }
    return localStorage.getItem('userId');
};

// Store user info in session storage
export const setUserInfo = (userInfo) => {
    if (!userInfo) return;

    try {
        sessionStorage.setItem('user', JSON.stringify(userInfo));
    } catch (error) {
        console.error('Error storing user info:', error);
    }
};

// Get user info from session storage
export const getUserInfo = () => {
    try {
        const userInfo = sessionStorage.getItem('user');
        return userInfo ? JSON.parse(userInfo) : null;
    } catch (error) {
        console.error('Error retrieving user info:', error);
        return null;
    }
};

//this is added for the Role-based Redirection
// Add these functions to tokenService.js
export const clearAuthData = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userRole');
};